import './styles.scss';

export const Tickets = () => {
  return (
    <div className='tickets-wrapper'>
      <iframe src='https://events.barbershop.de/bmf2024register/' title='description'></iframe>
    </div>
  )
}